import LambdaApiService from '@/services/apiService/lambda';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreDtwinRuleEditMetrics',
  props: {
    rule: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    // the states that are to be displayed / edited
    states: {
      type: Array,
      required: true
    },
    templateContext: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      operations: [{
        value: 'sum',
        text: 'SUM()'
      }, {
        value: 'count',
        text: 'COUNT()'
      }, {
        value: 'min',
        text: 'MIN()'
      }, {
        value: 'max',
        text: 'MAX()'
      }, {
        value: 'avg',
        text: 'AVG()'
      }, {
        value: 'last',
        text: 'LAST()'
      }, {
        value: 'since_last_update',
        text: 'SINCE_LAST_UPDATE()'
      }],
      operators: [{
        value: 'and',
        text: 'AND'
      }, {
        value: 'or',
        text: 'OR'
      }],
      transformerErrors: {},
      stateMetricKeyUnique: [v => !!v && /^[A-Za-z]{1}[A-Za-z0-9_]*$/g.exec(v) !== null || this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.stateMetricKeyAlert'), v => !!v && this.rule.properties.stateMetrics.filter(s => s.key === v).length <= 1 || 'Must have a unique name'],
      stateMetricTransformerValid: [v => !!v && this.transformerErrors[v] === undefined || this.transformerErrors[v] || 'Must specify a valid transformer'],
      requiredRule: [v => !!v || this.$i18n_t('Common.fieldRequired')]
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])
  },
  methods: {
    evaluateTransformer(stateMetric) {
      const transform = stateMetric.transform;
      const script = `module.exports = (x) => {
        return ${transform};
      }`;
      return LambdaApiService.evaluateScript({
        script,
        scriptParams: [42]
      }).then(result => {
        // TODO: clean up unused/outdated transformer errors(?)
        if (result.syntaxError) {
          this.transformerErrors[transform] = result.syntaxError;
          this.transformerErrors = cloneDeep(this.transformerErrors);
          this.validateForm();
        }
      });
    },
    stateIsNumeric(stateMetric) {
      const searchField = this.templateContext ? 'key' : 'id';
      const identifierField = this.templateContext ? 'id' : 'stateId';
      const state = this.states.find(s => s[searchField] === stateMetric[identifierField]);
      if (state) {
        return state.properties.valueType === 'number';
      }
      return true;
    },
    stateTitle(stateMetric) {
      const searchField = this.templateContext ? 'key' : 'id';
      const identifierField = this.templateContext ? 'id' : 'stateId';
      const state = this.states.find(s => s[searchField] === stateMetric[identifierField]);
      if (state) {
        return state.properties.title;
      }
      return undefined;
    },
    editRuleOperationsForMetric(stateMetric) {
      const numericState = this.stateIsNumeric(stateMetric);
      if (!numericState) {
        return this.operations.filter(op => {
          return op.value === 'last' || op.value === 'since_last_update';
        });
      }
      return this.operations;
    },
    openDigitalTwinOfState(bindingId) {
      window.open(`#${this.$router.currentRoute.path}?stateId=${bindingId}`, '_blank');
    }
  }
};